import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  type FormControlLabelProps,
  FormLabel,
  LinearProgress,
  type StackProps,
} from '@mui/material'

import type { InputGroupLabels, InputLabels } from '@/features/search/constants'

interface Props<State extends Record<string, boolean>>
  extends Omit<FormControlLabelProps, 'onChange' | 'control' | 'label'> {
  label: string
  fieldName: string
  direction?: StackProps['direction']
  state: State
  checkboxDetails: InputGroupLabels<State>
  onChange?: (key: keyof State | string, checked: boolean) => any
  isLoading?: boolean
}

export function CheckboxGroup<State extends Record<string, boolean>>(
  props: Props<State>,
) {
  const {
    direction = 'row',
    fieldName = '',
    label = '',
    isLoading = false,
  } = props

  const handleChange = (key: string, checked: boolean) => {
    if (props.onChange) props.onChange(key, checked)
  }

  const checkboxes = Object.entries<InputLabels>(props.checkboxDetails).map(
    ([key, value]) => {
      return (
        <FormControlLabel
          key={key}
          name={key}
          label={value.label}
          control={<Checkbox />}
          checked={props.state[key] ?? false}
          onChange={(_event, checked) => handleChange(key, checked)}
        />
      )
    },
  )

  return (
    <FormControl>
      <FormLabel id={fieldName}>{label}</FormLabel>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Box display="flex" flexDirection={direction} flexWrap="wrap">
          {checkboxes}
        </Box>
      )}
    </FormControl>
  )
}
